// DatePickerDropdown.tsx
import React, { useState, useEffect, useRef } from "react";
import DatePicker from "./DatePicker";
import { FaChevronDown } from "react-icons/fa";
const ChevronDownIcon = FaChevronDown as React.FC<React.SVGProps<SVGSVGElement>>;

interface DatePickerDropdownProps {
  label: string;
  onSelect: (dates: { MoveInDate: string; MoveOutDate: string; NoOfDays: number }) => void;
}

const DatePickerDropdown: React.FC<DatePickerDropdownProps> = ({ label, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleApply = (dates: { MoveInDate: string; MoveOutDate: string; NoOfDays: number }) => {
    onSelect(dates);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        onClick={toggleDropdown}
        className="inline-flex items-center space-x-1.5 rounded-md border border-[#E2E8F0] bg-white px-4 py-1.5 text-sm font-medium text-[#0F172A] hover:border-pink-500 focus:outline-none focus:ring-2 focus:ring-pink-200 transition"
      >
        <span>{label}</span>
        {/* <ChevronDownIcon
          size={12}
          className={`transform transition-transform duration-150 ${isOpen ? "rotate-180" : ""} text-[#0F172A]`}
        /> */}
      </button>
      {isOpen && (
        <div className="absolute left-0 mt-2 min-w-[650px] bg-white rounded-xl shadow-lg border border-gray-200 z-10 p-4">
          <DatePicker onApply={handleApply} />
        </div>
      )}
    </div>
  );
};

export default DatePickerDropdown;
